import counterService from './counter.service'
import customerService from './customer.service'
import currencyService from './currency.service'
import exchangeRateService from './exchange-rate.service'
import productCategoryService from './product-category.service'
import productService from './product.service'
import settingsService from './settings.service'
import paymentResourceService from './payment-resource.service'
import promotionService from './promotion.service'
import {
  buildProductQuery,
  getProductPagination,
  mapProducts
} from '../utils/product'
import { findGeneralCustomer } from '../utils/customer'
import retailSaleOrderService from './retail-sale-order.service'

export const saveRetailSale = (payload, idempotencyKey) =>
  retailSaleOrderService.create(payload, idempotencyKey)

export const fetchCurrency = () =>
  currencyService.get().then(response => ({
    currency: response.data || {},
    currencies: response.currencies || []
  }))

export const fetchCounters = () =>
  counterService.get().then(response => response.data || [])

export const fetchExchangeRates = () =>
  exchangeRateService.get().then(response => response.data || [])

export const fetchSettings = () =>
  settingsService.get().then(response => response.data || {})

export const fetchPaymentResources = () =>
  paymentResourceService.get().then(response => response.data || {})

export const fetchPromotions = () =>
  promotionService.get().then(response => response.data || [])

export const fetchProductCategories = () =>
  productCategoryService.get().then(response => response.data || [])

export const fetchCustomers = async () => {
  const response = await customerService.get({ params: { perPage: 1000 } })
  const customers = response.data || []

  return {
    customers,
    generalCustomer: findGeneralCustomer(customers)
  }
}

export const fetchProducts = async (order, page) => {
  const params = buildProductQuery(order, page)
  const response = await productService.get({ params })
  const products = mapProducts(response.data)
  const pagination = getProductPagination(response.meta, page, products.length)

  return { params, products, pagination }
}

export const fetchProductSaleCodes = async productId => {
  const response = await productService.getSaleCodes(productId)

  return response.data || []
}

/** Resolve a scanned barcode without relying on the paginated product grid. */
export const fetchProductByBarcode = async (barcode, scale = false) => {
  const response = await productService.getByBarcode(barcode, scale)

  return mapProducts([response.data])[0]
}

export default {
  fetchCurrency,
  fetchCounters,
  fetchExchangeRates,
  fetchSettings,
  fetchPaymentResources,
  fetchPromotions,
  fetchProductCategories,
  fetchCustomers,
  fetchProducts,
  fetchProductSaleCodes,
  fetchProductByBarcode,
  saveRetailSale
}
